<template>
    <mdb-container fluid v-if="product" class="bg-white py-3">
        <h1>
            {{ product.name }}
        </h1>
        <h3> {{ product.description }}</h3>

        <div v-for="item in product.files" :key="item.id">
            <div v-if="item.components_data_media_id.media_file">
              <download-link :uri="item.components_data_media_id.media_file" :name="item.components_data_media_id.title" />
            </div>
            <div v-else>
              <mdb-icon icon="file-download" />
              {{ item.components_data_media_id.title }}
            </div>
        </div>
    </mdb-container >
</template>

<script>

    import axios from 'axios'
    import {
        mdbContainer,
        mdbIcon

    } from "mdbvue";

    import DownloadLink from "../link/DownloadLink.vue";
    export default {
        name: "product",
        components: {
          DownloadLink,
          mdbContainer,
          mdbIcon
        },
        data() {
            return {
                productID: this.$route.params.id,
                product: null,
                contentBase: process.env.VUE_APP_CONTENT_2_URL,
                token: process.env.VUE_APP_CONTENT_2_REST_TOKEN
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/product/' + this.productID + '?fields=*.*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN,  {headers:{Authorization: ''}})
                .then(response => this.product = response.data.data);
        }
    }
</script>

<style scoped>

</style>